import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import type {
  IPostbackTrackerEditPayload,
} from '../types';
import {
  ADMIN_POSTBACKS_TRACKERS_SAVE_URL,
  AFFILIATE_POSTBACKS_TRACKERS_SAVE_URL,
  POSTBACKS_SAVE_TRACKERS_MUTATION_KEY,
} from '../constants';

export default function usePostbackTrackersSaveMutation(): IContextMutationResult<
  void,
  Error,
  IPostbackTrackerEditPayload
> {
  const { fetchPut } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<void, Error, IPostbackTrackerEditPayload>({
    mutationKey: [POSTBACKS_SAVE_TRACKERS_MUTATION_KEY],
    mutationFn: ({
      affiliateId,
      id,
      addType,
      ...serial
    }) => fetchPut<void>(
      isAdminNamespace.value ? ADMIN_POSTBACKS_TRACKERS_SAVE_URL : AFFILIATE_POSTBACKS_TRACKERS_SAVE_URL,
      {
        serial,
      },
      {
        permission: POSTBACKS_PERMISSIONS.SHOW,
        urlParams: {
          id: affiliateId,
          postbackId: id,
          addType,
        },
      },
    ),
  });
}
